import React from 'react';
import LessonHome from '../LessonHome';

const Lesson8 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson8;